<template>
  <div>
    <!-- <v-card class="pa-4">
      <v-row class="text-center">
        <v-col cols="3">
          <v-skeleton-loader type="text"></v-skeleton-loader>
          <v-skeleton-loader type="heading"></v-skeleton-loader>
          <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader type="text"></v-skeleton-loader>
          <v-skeleton-loader type="heading"></v-skeleton-loader>
          <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader type="text"></v-skeleton-loader>
          <v-skeleton-loader type="heading"></v-skeleton-loader>
          <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-col>
        <v-col cols="3">
          <v-skeleton-loader type="text"></v-skeleton-loader>
          <v-skeleton-loader type="heading"></v-skeleton-loader>
          <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card> -->

    <!-- Account List Section -->
    <v-card class="mt-4" v-for="n in 3" :key="n">
      <v-row align="center" class="pa-4">
        <v-col cols="1">
          <v-skeleton-loader type="avatar"></v-skeleton-loader>
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
